import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/react'
import { Link } from 'gatsby'
import { MAX_SEARCH_RESULTS_COUNT } from '../../../constants'
import ArrowRightIcon from '../../../assets/icons/arrow-right-blue.inline.svg'

const btnCss = (isActive) => (theme) =>
  css`
    background-color: ${isActive ? theme.colors.gray50 : theme.colors.gray40};
    max-height: 32px;
    border-radius: 0 0 4px 4px;

    > a {
      justify-content: center;
      font-size: 15px;
      line-height: 22px;
      color: ${isActive ? theme.colors.blue600 : theme.colors.blue500};

      > span {
        display: flex;
        align-items: center;

        svg,
        svg > path {
          fill: ${isActive ? theme.colors.blue600 : theme.colors.blue500};
        }
      }
    }
  `

const arrowIconCss = css`
  background: none;
  border: 0;
  margin-left: 6px;
  margin-bottom: 1px;
`

const MoreResultsButton = ({
  items,
  query,
  onActiveItemIndexChange,
  isMoreResultsActive,
}) => {
  const itemsCount = (items && items.length) || 0
  const moreResultsCount = itemsCount - MAX_SEARCH_RESULTS_COUNT

  const copy = `See ${moreResultsCount} more result${
    moreResultsCount > 1 ? 's' : ''
  }`

  return (
    <li
      className="autocomplete-item"
      css={btnCss(isMoreResultsActive)}
      onMouseEnter={() =>
        onActiveItemIndexChange(MAX_SEARCH_RESULTS_COUNT, true)
      }
    >
      <Link className="autocomplete-item__link" to={`/search/?query=${query}`}>
        <span>
          {copy}
          <ArrowRightIcon width={11} height={11} css={arrowIconCss} />
        </span>
      </Link>
    </li>
  )
}

MoreResultsButton.propTypes = {
  items: PropTypes.array,
  query: PropTypes.string,
  isMoreResultsActive: PropTypes.bool,
  onActiveItemIndexChange: PropTypes.func,
}

export default MoreResultsButton
